import { Box, Button, Chip, Typography } from "@mui/material";
import { useState } from "react";

export interface PropertyWithExamples {
	name: string;
	examples: string[];
}

interface GeoJsonPropertiesChipsProps {
	featureProperties: PropertyWithExamples[];
}

export { type GeoJsonPropertiesChipsProps };

export default function GeoJsonPropertiesChips({ featureProperties }: GeoJsonPropertiesChipsProps) {
	const [showAllProperties, setShowAllProperties] = useState(false);

	// Filter out FilePath and FolderLevelN properties
	const filteredProperties = featureProperties.filter(
		(property) => property.name !== "FilePath" && !property.name.startsWith("FolderLevel"),
	);

	if (filteredProperties.length === 0) {
		return null;
	}

	return (
		<Box sx={{ mt: 2, mb: 2 }}>
			<Typography variant="subtitle1" sx={{ mb: 1, fontWeight: "bold" }}>
				Properties:
			</Typography>
			<Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, alignItems: "center" }}>
				{filteredProperties.slice(0, showAllProperties ? undefined : 10).map((property) => (
					<Chip
						key={property.name}
						label={
							<span>
								<strong>{property.name}:</strong> {property.examples.join(", ")}
							</span>
						}
						variant="outlined"
						size="small"
						sx={{
							maxWidth: "300px",
							"& .MuiChip-label": {
								whiteSpace: "nowrap",
								overflow: "hidden",
								textOverflow: "ellipsis",
								display: "block",
							},
						}}
					/>
				))}
				{filteredProperties.length > 10 && (
					<Button size="small" onClick={() => setShowAllProperties(!showAllProperties)} sx={{ minWidth: "auto" }}>
						{showAllProperties ? "Show less" : `Show ${filteredProperties.length - 10} more`}
					</Button>
				)}
			</Box>
		</Box>
	);
}
